import { FormState, SidebarPanelProps } from "../../../../../types/product";

function seoScore(form: FormState): number {
    let score = 0;
    if ((form.tab_name || "").trim()) score += 20;
    if (form.product_description.length >= 80) score += 20;
    if (form.meta_title.length >= 40 && form.meta_title.length <= 60) score += 25;
    if (
        form.meta_description.length >= 100 &&
        form.meta_description.length <= 160
    )
        score += 25;
    if (form.product_specifications.filter((s) => s.key.trim()).length >= 3)
        score += 10;
    return score;
}

export default function SeoScorePanel({ form }: SidebarPanelProps) {
    const score = seoScore(form);
    const scoreColor = score >= 75 ? "#6ddc6d" : score >= 45 ? "#f5a623" : "#e05252";
    const scoreLabel = score >= 75 ? "Good" : score >= 45 ? "Needs work" : "Poor";
    const radius = 22;
    const circumference = 2 * Math.PI * radius; // r=22

    const checks: { label: string; pass: boolean }[] = [
        { label: "Product name set", pass: !!(form.tab_name || "").trim() },
        { label: "Description ≥ 80 chars", pass: form.product_description.length >= 80 },
        { label: "Meta title 40–60 chars", pass: form.meta_title.length >= 40 && form.meta_title.length <= 60 },
        { label: "Meta desc 100–160 chars", pass: form.meta_description.length >= 100 && form.meta_description.length <= 160 },
        { label: "3+ specifications added", pass: form.product_specifications.filter((s) => s.key.trim()).length >= 3 },
    ];

    return (
        <div style={{ background: "var(--card)", border: "1px solid var(--border)", borderRadius: 14, overflow: "hidden" }}>
            <div style={{
                display: "flex", alignItems: "center", gap: 10, padding: "14px 20px",
                borderBottom: "1px solid var(--border)", background: "var(--section-header)",
            }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "var(--text)", flex: 1 }}>SEO Score</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: scoreColor }}>{scoreLabel}</span>
            </div>
            <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 14 }}>
                {/* Score ring + blurb */}
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div style={{ position: "relative", width: 56, height: 56, flexShrink: 0 }}>
                        <svg width="56" height="56" viewBox="0 0 56 56">
                            <circle cx="28" cy="28" r={radius} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="5" />
                            <circle cx="28" cy="28" r={radius} fill="none" stroke={scoreColor} strokeWidth="5"
                                strokeDasharray={`${(score / 100) * circumference} ${circumference}`}
                                strokeLinecap="round" transform="rotate(-90 28 28)"
                                style={{ transition: "stroke-dasharray 0.5s ease" }}
                            />
                        </svg>
                        <div style={{
                            position: "absolute", inset: 0, display: "flex",
                            alignItems: "center", justifyContent: "center",
                            fontSize: 14, fontWeight: 600, color: scoreColor,
                        }}>
                            {score}
                        </div>
                    </div>
                    <p style={{ margin: 0, fontSize: 12, color: "var(--text3)", lineHeight: 1.6 }}>
                        Complete all checks below to maximise search visibility.
                    </p>
                </div>
                {/* Checklist */}
                <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
                    {checks.map((c) => (
                        <div key={c.label} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <div style={{
                                width: 16, height: 16, borderRadius: "50%", flexShrink: 0,
                                background: c.pass ? "rgba(109,220,109,0.12)" : "rgba(255,255,255,0.05)",
                                border: `1px solid ${c.pass ? "rgba(109,220,109,0.3)" : "var(--border)"}`,
                                display: "flex", alignItems: "center", justifyContent: "center",
                                fontSize: 10, color: c.pass ? "#6ddc6d" : "var(--text3)",
                                transition: "all 0.2s",
                            }}>
                                {c.pass ? "✓" : "·"}
                            </div>
                            <span style={{ fontSize: 12, color: c.pass ? "var(--text2)" : "var(--text3)", transition: "color 0.2s" }}>
                                {c.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
